import { render, staticRenderFns } from "./IndexInformation.html?vue&type=template&id=942b3fba&scoped=true&"
import script from "./IndexInformation.js?vue&type=script&lang=js&"
export * from "./IndexInformation.js?vue&type=script&lang=js&"
import style0 from "./IndexInformation.scss?vue&type=style&index=0&id=942b3fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942b3fba",
  null
  
)

export default component.exports